import { render, staticRenderFns } from "./Race.vue?vue&type=template&id=1aeb5ebb&scoped=true&"
import script from "./Race.vue?vue&type=script&lang=js&"
export * from "./Race.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeb5ebb",
  null
  
)

export default component.exports